<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'app'
}
</script>

<style lang="less">
html {
    font-family: sans-serif;
}

body {
    padding: 0px;
    margin: 0px auto;
}

textarea {
    font-family: sans-serif;
}

* {
    margin: 0;
    padding: 0;
}

a {
    text-decoration: none;
}

#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: left;
    color: #2c3e50;
}

.el-upload-list__item-status-label {
    display: none !important;
}

.el-upload-list__item {
    position: relative;
}

.el-upload-list__item-thumbnail {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 100% !important;
    height: auto !important;
}

.el-menu--popup-right-start {
    background-color: #333744 !important;
}

.el-date-editor {
    input {
        cursor: pointer;
    }
}

.col-page {
    text-align: center;
    margin: 50px 0;
}

.upload-img {
    .el-upload-list {
        margin-left: -20px;
        display: inline-block;
    }
    .el-upload-list__item {
        cursor: pointer;
        width: 146px !important;
        height: 146px !important;
        padding: 20px 0 !important;
        box-sizing: border-box !important;
        float: left;
        margin: 0 0 20px 20px;
        img {
            width: 100% !important;
            height: 100% !important;
            max-width: 100%;
            max-height: 100%;
            margin: 0;
        }
        .el-icon-close {
            z-index: 9;
            opacity: 1;
            color: #c00200;
            font-weight: bold;
        }
    }
}

.el-dialog {
    .el-dialog__body {
        padding: 10px 20px;
    }
}

.form-inline {
    margin-bottom: 22px;
    padding: 0;
    display: inline-block;
    width: 100%;
    box-sizing: border-box;
    .search-item {
        margin: 30px 0 0;
    }
}

.operate-btn-group {
    padding-top: 7px !important;
    .el-button {
        margin-top: 5px;
    }
}

.el-table thead th {
    background: #f5f7fa;
}
.el-table th.gutter {
    display: table-cell !important
}

.gather-form {
    display: table;
    width: 100%;
    border-left: 1px solid #c9c9c9;
    border-top: 1px solid #c9c9c9;
    border-bottom: 1px solid #c9c9c9;
    .form-group {
        display: table-cell;
        text-align: center;
        border-right: 1px solid #c9c9c9;
        padding: 15px 0;
        background-color: #fff;
        &.small-group {
            padding: 10px 0;   
            text-align: left;
            p {
                font-size: 14px;
                margin-bottom: 0;
            }
            .el-button--mini {
                padding: 5px;
            }
        }
        p {
            font-size: 14px;
            margin-bottom: 15px;
        }
    }
    .active-form-group {
        background-color: #409EFF;
        color: #fff;
    }
    .item-six {
        width: 16.66%;
    }
    .item-cell {
        width: 20%;
    }
    .item-four {
        width: 25%;
    }
    .item-three {
        width: 33.33%;
    }
}

.service-types-tips {
    color: #8492a6;
    font-size: 14px;
    margin-left: 10px;
}

.edui-toolbar .edui-default {
    line-height: 20px !important;
}

.ue {
    .el-form-item__content {
        // width: 100%;
        overflow: hidden;
    }

    .el-form-item__error {
        margin-top: -40px;
    }
}
</style>


// WEBPACK FOOTER //
// App.vue?b412bcd8